export const getHeaders = (apiKey, authToken) => {
    const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Access-Control-Allow-Origin", "*");
        headers.append("Access-Control-Allow-Headers", "Origin, X-Requested-With, Content-Type, Accept");
        headers.append("x-api-key", apiKey);
        
    if (authToken) {
        headers.append("Authorization", authToken);
    }

    return headers;
}